import colors from 'src/theme/colors';
import { defineSlotRecipe } from '@chakra-ui/react';
import fonts from '../fonts';

const Field = defineSlotRecipe({
  slots: [
    'root',
    'errorText',
    'helperText',
    'input',
    'label',
    'select',
    'textarea',
    'requiredIndicator',
  ],
  base: {
    label: {
      fontFamily: fonts.bold,
      fontSize: '1rem',
      pl: 0,
      lineHeight: '1.5rem',
      color: 'podcastShade600',
      width: 'max-content',
    },
    helperText: {
      fontSize: '13px',
    },
    errorText: {
      width: '100%',
      bg: 'podcastRed100',
      borderColor: 'podcastRed400',
      borderWidth: '1px',
      borderStyle: 'solid',
      padding: '8px',
      borderRadius: '8px',
    },
  },
  variants: {
    visual: {
      primary: {},
      insideInput: {
        label: {
          fontFamily: fonts.normal,
          alignItems: 'top',
          pl: '20px',
          fontSize: 13,
          lineHeight: '1.2rem',
          borderRadius: 12,
          position: 'absolute',
          top: 0,
          left: 0,
          h: '60px',
          w: '100%',
          pt: '8px',
          boxShadow: 'inset 0px -3px 10px rgba(205, 204, 227, 0.2)',
          border: '1px solid',
          borderColor: 'podcastShade300',
          color: 'podcastShade600',
          _groupHover: {
            boxShadow: 'none',
          },
          _focus: {
            border: '2px solid',
            pt: '7px',
            pl: '19px',
            borderColor: colors.podcastPurple,
            _invalid: {
              border: `2px solid ${colors.podcastRed400}`,
            },
          },
          _invalid: {
            border: `1px solid ${colors.podcastRed400}`,
            boxShadow: 'inset 0px -3px 6px rgba(239, 57, 113, 0.05)',
          },
          _disabled: {
            background: colors.podcastShade100,
            opacity: 1,
          },
        },
      },
      large: {
        label: {
          fontFamily: fonts.bold,
          fontSize: '1rem',
          pl: 0,
          lineHeight: '1.5rem',
          color: 'podcastShade600',
          width: 'max-content',
        },
      },
    },
  },
  defaultVariants: {
    visual: 'primary',
  },
});

export default Field;
